"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentPackageConverter = void 0;
class ContentPackageConverter {
    static convertPackages(response) {
        return response.data._embedded.contentPackages.map(this.convertPackage);
    }
    static convertPackage(data) {
        return {
            id: data.id,
            name: data.name,
            accessRules: data.accessRules.map((accessRule) => ({
                type: accessRule.type,
                videoIds: accessRule.videoIds || undefined,
                collectionIds: accessRule.collectionIds || undefined,
                channelIds: accessRule.channelIds || undefined,
                distributionMethods: accessRule.distributionMethods || undefined,
                videoTypes: accessRule.videoTypes || undefined,
                languages: accessRule.languages || undefined,
                categoryCodes: accessRule.categoryCodes || undefined,
                subjectIds: accessRule.subjectIds || undefined,
                voiceTypes: accessRule.voiceTypes || undefined,
                sources: accessRule.sources || undefined,
                educationLevelCodes: accessRule.educationLevelCodes || undefined,
                contentWarningIds: accessRule.contentWarningIds || undefined,
            })),
            accountsConnected: data.accountsConnected,
        };
    }
}
exports.ContentPackageConverter = ContentPackageConverter;
//# sourceMappingURL=ContentPackageConverter.js.map